// Centralised Supabase endpoint constants.
//
// The generated `client.ts` hard-codes these but does not export them, and it is
// marked "do not edit" (Lovable re-generates it). The reader-hub chat needs the
// project URL + anon key to stream Server-Sent Events via `fetch` (the JS client
// buffers SSE). Keeping them here means the hard-coded base URL lives in exactly
// one place and survives a Lovable re-sync of `client.ts`.
export const SUPABASE_URL = "https://ewyfhrjexfrmcjhqzsmm.supabase.co";
export const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV3eWZocmpleGZybWNqaHF6c21tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2MDQ1NjIsImV4cCI6MjA3MzE4MDU2Mn0.sfY5nq_bJY7_c1qlf_DgMZXDhITWUo0c6TZLr2yzGJ8";
